import {
    ORDER_CREATE_REQUEST,
    ORDER_CREATE_SUCCESS,
    ORDER_CREATE_FAIL,

    ORDER_DETAILS_REQUEST,
    ORDER_DETAILS_SUCCESS,
    ORDER_DETAILS_FAIL,

    ORDER_LIST_MY_REQUEST,
    ORDER_LIST_MY_SUCCESS,
    ORDER_LIST_MY_FAIL,

} from '../constants/orderConstants'

import { CART_CLEAR_ITEMS } from '../constants/cartConstants'
import { BASE_URL } from '../constants/urlConstants'
import axiosInstance from '../utils/axiosInstance'
import axios from "axios"

export const createOrder = (order) => async (dispatch, getState) => {
    try {
        dispatch({ type: ORDER_CREATE_REQUEST })

        const { userLogin: { userInfo } } = getState()

        const authRequestAxios = axiosInstance(userInfo, dispatch)

        const { data } = await authRequestAxios.post(
            `${BASE_URL}/orders/add/`,
            order
        )

        dispatch({ type: ORDER_CREATE_SUCCESS, payload: data })

        dispatch({ type: CART_CLEAR_ITEMS })

        localStorage.removeItem('cartItems')
    } catch (error) {
        dispatch({
            type: ORDER_CREATE_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message
        })
    }
}


export const getOrderDetails = (kit,id) => async (dispatch) => {
    try {
        dispatch({ type: ORDER_DETAILS_REQUEST })

        // const { userLogin: { userInfo } } = getState()

        // const authRequestAxios = axiosInstance(userInfo, dispatch)

        const { data } = await axios.get(
            `${BASE_URL}/orders/${kit}/${id}/`
        )

        dispatch({ type: ORDER_DETAILS_SUCCESS, payload: data })

    } catch (error) {
        dispatch({
            type: ORDER_DETAILS_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message
        })
    }
}


export const getMyOrderList = () => async (dispatch, getState) => {
    try {
        dispatch({ type: ORDER_LIST_MY_REQUEST })

        const { userLogin: { userInfo } } = getState()

        const authRequestAxios = axiosInstance(userInfo, dispatch)

        const { data } = await authRequestAxios.get(
            `${BASE_URL}/orders/my/`,
        )

        dispatch({ type: ORDER_LIST_MY_SUCCESS, payload: data })
    } catch (error) {
        dispatch({
            type: ORDER_LIST_MY_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message
        })
    }
}


export const goPayGate = ( id,price,address,code) => {

    const response = axios.post(
        `${BASE_URL}/orders/pay/`,
        { 'orderId': id, 'price': price ,'address':address, 'code': code}
            
    )
    return response
}

export const goPayPasargadGate = ( id,price,address,code) => {

    const response = axios.post(
        `${BASE_URL}/orders/pasargadpay/`,
        { 'orderId': id, 'price': price ,'address':address, 'code': code}
    
    )
    return response
}

export const goPayPasargadFakeGate = ( price) => {

    const response = axios.post(
        `${BASE_URL}/orders/pasargadfakepay/`,
        { 'price': price }
    
    )
    return response
}

export const inquiryPayResult = (payInq) => {

    const response = axios.post(
        `/orders/inquirypay/`,
        payInq
    )
    return response
}


